import React from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';

// icon
import PeopleIcon from '@material-ui/icons/People';

import Login from '../../containers/Header/login';

// context
import UserContext from '../../context/UserContext';

export default function Private() {
  return (
    <Grid container justifyContent="center">
      <UserContext.Consumer>
        {(user) => (<>{user.firstname}</>)}
      </UserContext.Consumer>
      <Grid item xs={10} lg={12}>
        <Typography component="div" variant="h5" align="center">
          <Box color="primary.main" style={{ marginTop: '5%' }}>
            <PeopleIcon />
            {' '}
            สำหรับเจ้าหน้าที่
          </Box>
        </Typography>
      </Grid>
      <Grid item xs={10} lg={3}>
        <Login />
      </Grid>
    </Grid>
  );
}
